import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticssmsanalysis',
  templateUrl: './analyticssmsanalysis.component.html',
  styleUrls: ['./analyticssmsanalysis.component.css']
})
export class AnalyticssmsanalysisComponent implements OnInit {
  @Input('details') details: any;
  sms_details: any [];
  loan_sms_details: any [];
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;

  constructor() {
  }

  ngOnInit() { 
    // this.sms_details = this.details.airtime_info.latest_twenty_sms;
    // this.loan_sms_details = this.details.loan_info.loan_related_sms;
    // this.phone_ownership = this.details.phone_ownership.phone_ownership_credibility;
    // this.average_credit = this.details.airtime_info.airtime_monthly_average;
    // this.average_income = this.details.credit_info.average;
    // this.salary_amount = this.details.salary_info.salary_monthly_average;
  }

}
